export default class BPAbholungVerzehrartRequest {
  id: string
  verzehrart: string
}
